var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 36a3 3 0 100-6 3 3 0 000 6z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 12v6h-1.5A4.501 4.501 0 006 22.5v21c0 2.484 2.016 4.5 4.5 4.5h27c2.484 0 4.5-2.016 4.5-4.5v-21c0-2.484-2.016-4.5-4.5-4.5H36v-6c0-6.626-5.374-12-12-12S12 5.374 12 12zm12-9a9 9 0 00-9 9v6h18v-6a9 9 0 00-9-9zM9 22.5a1.5 1.5 0 011.5-1.5h27a1.5 1.5 0 011.5 1.5v21a1.5 1.5 0 01-1.5 1.5h-27A1.5 1.5 0 019 43.5v-21z","key":1})]);
}

Lock.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Lock;

Lock.default = Lock;
